export const selectQuery = state => state.searchProvider;
